import { isMobile, isTablet } from 'react-device-detect';
import * as storageHelper from './storage-helper';

export interface MobileSessionWatchTarget {
  isAuthenticated: () => boolean;
  isChecking: () => boolean;
  setChecking: (checking: boolean) => void;
  checkAuthentication: () => unknown;
}

// On phones and tablets the Teams client can drop the SMG cookies while a page stays open. Instead of sending the
// user straight to the login page, checkAuthentication restores the session from the backend first; if that fails it
// clears isAuthenticated and the page's own Navigate opens the login page (TEAM-1883).
// Returns a function that stops the watch; pages call it when they unmount so navigating between pages does not
// leave several watches polling with stale props.
export function watchMobileSession(target: MobileSessionWatchTarget): () => void {
  if (!isMobile && !isTablet) {
    return () => undefined;
  }

  const interval = setInterval(() => {
    if (!storageHelper.getSmgAccessToken() && target.isAuthenticated() && !target.isChecking()) {
      target.setChecking(true);
      Promise.resolve(target.checkAuthentication()).finally(() => target.setChecking(false));
    }
  }, 1000);

  return () => clearInterval(interval);
}
